let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5jFSj")).then(() => parcelRequire('4fHnG'));